import { render, staticRenderFns } from "./AbaTroncoKhomp.vue?vue&type=template&id=6ff8806e&scoped=true&"
import script from "./AbaTroncoKhomp.vue?vue&type=script&lang=js&"
export * from "./AbaTroncoKhomp.vue?vue&type=script&lang=js&"
import style0 from "./AbaTroncoKhomp.vue?vue&type=style&index=0&id=6ff8806e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff8806e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VCol,VDivider,VForm,VRow,VSheet,VSkeletonLoader,VTextField})
